// src/app/interceptors/ssr-data.interceptor.ts
import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject, makeStateKey, TransferState } from '@angular/core';
import { Observable, of } from 'rxjs';

export const ssrDataInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>, 
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const transferState = inject(TransferState);
  
  // Extract the path from the URL to create a matching key pattern
  const urlPath = req.url.replace(/^(https?:\/\/[^\/]+)?\/api\//, '');
  
  // Check for job details request
  if (urlPath.match(/^jobs\/[^\/]+$/)) {
    const jobId = urlPath.split('/').pop();
    const stateKey = makeStateKey('SSR_JOB_DETAILS');
    
    if (transferState.hasKey(stateKey)) {
      const jobData = transferState.get(stateKey, null);
      transferState.remove(stateKey); // Clean up after use
      
      // Return a properly typed HttpResponse
      return of(new HttpResponse({
        body: jobData,
        status: 200,
        statusText: 'OK',
      }));
    }
  }
  
  // Check for candidate details request
  if (urlPath.match(/^candidates\/[^\/]+$/)) {
    const candidateId = urlPath.split('/').pop();
    const stateKey = makeStateKey('SSR_CANDIDATE_DETAILS');
    
    if (transferState.hasKey(stateKey)) {
      const candidateData = transferState.get(stateKey, null);
      transferState.remove(stateKey); // Clean up after use
      
      // Return a properly typed HttpResponse
      return of(new HttpResponse({
        body: candidateData,
        status: 200,
        statusText: 'OK',
      }));
    }
  }
  
  // Check for jobs list request
  if (urlPath.match(/^jobs(\?.*)?$/)) {
    const stateKey = makeStateKey('SSR_JOBS_LIST');
    
    if (transferState.hasKey(stateKey)) {
      const jobsData = transferState.get(stateKey, null);
      transferState.remove(stateKey); // Clean up after use
      
      // Return a properly typed HttpResponse
      return of(new HttpResponse({
        body: jobsData,
        status: 200,
        statusText: 'OK',
      }));
    }
  }
  
  // Continue with the request if no matching SSR data is found
  return next(req);
};